import React from 'react';
import { VisitStatusPill } from '../../common/Pills';

interface Props {
  status: string;
  size?: 'sm' | 'md';
  className?: string;
}

export function VisitStatusBadge({ status, size = 'md', className = '' }: Props) {
  const sizeClass = size === 'sm' ? '' : 'px-2.5 py-1 text-sm';
  return <VisitStatusPill status={status} className={`${sizeClass} ${className}`.trim()} />;
}
